module.exports = "/fast-coin/img/coin/anim/shine_2/shine_2_025.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_2/shine_2_025.png
// module id = 2372
// module chunks = 5